import React from 'react';

import Url from '../../src/Url';
import Image3 from '../../src/Images/bombay.png';


export const NavMenu = ({ onMouseEnter, onMouseLeave, index }) => {

  console.log('INDEXXXX=---> ', index);

  switch (index) {
    case 0:
      return (
        <div className="nav-menu">
          <div className="grid-container">
            {/* About Us Section */}
            <div className="col-span-5">
              <h1 className="font-bold text-xl">AI-Driven Innovation</h1>
              <div className="exp-pra soltionai">
                <p>
                We empower businesses by integrating 
                cutting-edge AI solutions that streamline operations, enhance decision-making
                and  drive innovation. 
                </p>
                <p className="mt-2">

                Our solutions are tailored to meet the 
                unique needs of your business, ensuring 
                you stay ahead of the curve.              
                  </p>
              </div>
              <div className="image-container">
                <img
                  src={`${Url.imageUrl}opt/ai_driven_innovation.webp`}
                  height={300}
                  width={300}
                  alt="ai_driven_innovation"
                  style={{marginTop:"30px"}}
                />
              </div>
            </div>

            {/* Links Section */}
            <div className="col-span-7">
              <div>
              <ul>
                  <li><a href="/solutions/facilities-management-software">Facility Management Software</a></li>
                  <li><a href="/solutions/handyman-management-software">Handyman Software</a></li>
                  <li><a href="/solutions/cleaning-management-software">Cleaning Management Software</a></li>
                  <li><a href="/">Truck booking Software</a></li>
                  <li><a href="/">Telemedicine Software</a></li>
                  <li><a href="/">Hospital Management Software</a></li>
                  <li><a href="/">E-Commerce Solution</a></li>
                  <li><a href="/">M-Commerce Solution</a></li>
                  <li><a href="/">Event Transportation Software</a></li>
                  <li><a href="/">Aircrew Transit Software</a></li>



                </ul>
              </div>
              <div>
              <ul>
              <li><a href="/">Employee Transportation Software</a></li>

              <li><a href="/">Corporate Carpooling Software</a></li>
                  <li><a href="/">NEMT Software</a></li>
                  <li><a href="/">Taxi Aggregator Software</a></li>
                  <li><a href="/">Bike Taxi Aggregator Software</a></li>
                  <li><a href="/">Fleet Management Software</a></li>
              <li><a href="/">Last-Mile Delivery Software</a></li>

                  <li><a href="/">Freight Bidding Software</a></li>

                </ul>
              </div>
              <div>
              <ul>
                <li><a href="/">Group Transportation Software</a></li>
                <li><a href="/">Shuttle & Bus Management Software</a></li>
                  <li><a href="/">Ride Sharing Software</a></li>
                  <li><a href="/">Vehicle Leasing Software</a></li>
                  <li><a href="/">EV Transportation Solutions</a></li>
                  <li><a href="/">Educational Transportation Solutions</a></li>

                </ul>
              </div>
            </div>
          </div>
        </div>
      );
    case 1:
      return (
        <div className="nav-menu">
          <div className="grid-container">
            {/* About Us Section */}
            <div className="col-span-5">
              <h1 className="font-bold text-xl">Comprehensive AI Services</h1>
              <div className="exp-pra serviceai">
                <p>
                From custom AI development to full-scale 
                data engineering and  consulting, we provide 
                end-to-end services that help businesses 
                harness the power of artificial intelligence
                to achieve measurable outcomes.            
                     </p>
                <p className="mt-2">
                Our team ensures that each solution is aligned 
                with your business objectives.                </p>
              </div>
              <div className="image-container">
                <img
                  src={`${Url.imageUrl}opt/comprehensive_ai_services.webp`}
                  height={300}
                  width={300}
                  alt="comprehensive_ai_services"
                  style={{marginTop:"30px"}}
                />
              </div>
            </div>

            {/* Links Section */}
            <div className="col-span-7">
              <div>
                <ul>
                  <li><a href="/">AI & ML Ecosystem</a></li>
                  <li><a href="/services/iot-development-services/">IoT Ecosystem</a></li>
                  <li><a href="/">Digital Transformation</a></li>
                  <li><a href="/">Digital Twin</a></li>
                  <li><a href="/">Cyber Resilience</a></li>
                  <li><a href="/">Cybersecurity Management</a></li>
                  <li><a href="/">Discovery, Prototyping & MVP</a></li>
                  <li><a href="/">Custom Mobile App Development</a></li>
                  <li><a href="/">IT Consulting</a></li>
                  <li><a href="/">Website Audit</a></li>

                </ul>
              </div>
              <div>
                <ul>
                  <li><a href="/">SEO Services</a></li>
                  <li><a href="/">UI/UX Designing</a></li>
                  <li><a href="/">Website Development</a></li>
                  <li><a href="/">QA Testing</a></li>
                  <li><a href="/">App Enhancement & Integration</a></li>
                  <li><a href="/">Staffing Services</a></li>
                  <li><a href="/">DevOps Services</a></li>
                  <li><a href="/">IT Maintenance & Support</a></li>
                  <li><a href="/">Digital Commerce</a></li>
                  <li><a href="/">Product Development</a></li>
                </ul>
              </div>
              <div>
                <ul>
                  <li><a href="/">Custom Software Development</a></li>
                  <li><a href="/">Cloud Services</a></li>
                  <li><a href="/">Robotic Process Automation</a></li>
                  <li><a href="/">Shopify Growth Consulting</a></li>

                </ul>
              </div>
            </div>
          </div>
        </div>
      );

    case 2:
      return (
        <div className="nav-menu">
          <div className="grid-container">
            {/* About Us Section */}
            <div className="col-span-5">
              <h1 className="font-bold text-xl">Transforming Key Industries</h1>
              <div className="exp-pra industriesai">
                <p>
                
                tr<span style={{color:"#3681f4", fontWeight:"bold"}}>AI</span>lique specializes in providing AI-driven 
                solutions across diverse industries, including healthcare, retail, finance and more.          
                     </p>
                <p className="mt-2">
                We enable organizations to optimize their operations, improve customer experiences and innovate within their markets through AI.                </p>
              </div>
              <div className="image-container">
                <img
                  src={`${Url.imageUrl}opt/transforming_key_industries.webp`}
                  height={300}
                  width={300}
                  alt="transforming_key_industries"
                  style={{marginTop:"50px"}}

                />
              </div>
            </div>

            {/* Links Section */}
            <div className="col-span-7">
              <div>
                <ul>
                  <li><a href="/">Healthcare</a></li>
                  <li><a href="/">Finance & Banking</a></li>
                  <li><a href="/">Retail & E-Commerce</a></li>
                  <li><a href="/">Manufacturing</a></li>
                  <li><a href="/">Transportation & <br/>Logistics</a></li>
                  <li><a href="/">Energy & Utilities</a></li>
                  <li><a href="/">Telecommunications</a></li>
                  <li><a href="/">Education</a></li>
                  <li><a href="/">Legal & Compliance</a></li>
                  <li><a href="/">Media & Entertainment</a></li>
                  <li><a href="/">Startups</a></li>
                  <li><a href="/">Real Estate</a></li>
                  
                 


                </ul>
              </div>
              <div>
                <ul>
                <li><a href="/">Automotive</a></li>
                <li><a href="/">Agriculture</a></li>
                  <li><a href="/">Public Sector & Government</a></li>
                  <li><a href="/">Insurance</a></li>
                  <li><a href="/">Hospitality & <br/>Tourism</a></li>
                  <li><a href="/">Oil & Gas</a></li>
                  <li><a href="/">Pharmaceuticals</a></li>
                  <li><a href="/">Food & Beverage</a></li>
                  <li><a href="/">Fashion & Apparel</a></li>
                  <li><a href="/">Construction  & Engineering</a></li>
                  
                  

                </ul>
              </div>
              <div>
                <ul>
                <li><a href="/">Aerospace &  Defence</a></li>
                <li><a href="/">Chemicals</a></li>
                <li><a href="/">Luxury Goods</a></li>
                <li><a href="/">Human Resources</a></li>
                  <li><a href="/">Mining & Natural Resources</a></li>
                  <li><a href="/">Nonprofit & NGOs</a></li>
                  <li><a href="/">Consumer Electronics</a></li>
                  <li><a href="/">Petrochemicals</a></li>
                  <li><a href="/">Publishing & Printing</a></li>
                  <li><a href="/">Logistics & Supply Chain</a></li>

                </ul>
              </div>
            </div>
          </div>
        </div>
      );


      case 4:
        return (
          <div className="nav-menu about-us-section">
            <div className="grid-container">
              {/* About Us Section */}
              <div className="col-span-5">
                <h1 className="font-bold text-xl">AI Experts You Can Trust</h1>
                <div className="exp-pra companyai">
                  <p>
                  
                  
At tr<span style={{color:"#3681f4", fontWeight:"bold"}}>AI</span>lique, we are passionate about pushing the boundaries of AI technology to help businesses succeed. 
                       </p>
                  <p className="mt-2">

                  With a dedicated team of experts and  a commitment to excellence, we partner with organizations globally to deliver transformative AI solutions.
                  </p>
                                  </div>
                <div className="image-container">
                  <img
                    src={`${Url.imageUrl}opt/ai_experts.webp`}
                    height={300}
                    width={300}
                    alt="ai_experts"
                    style={{marginTop:"30px"}}

                  />
                 
                </div>
              </div>
  
              {/* Links Section */}
              <div className="col-span-7 ">
                <div className='space'>
                  <ul>
                    <li><a href="/about-us">About</a></li>
                    <li><a href="/company/partners">Partners</a></li>
                    <li><a href="/">Media</a></li>
                    <li><a href="/">CSR</a></li>
                    
                  
  
  
                  </ul>
                </div>
                <div>
                  <ul>
                    <li><a href="/">The tr<span style={{color:"#3681f4", fontWeight:"bold"}}>AI</span>lique Way</a></li>
                    <li><a href="/technology-stack">Technology Stack</a></li>
                    <li><a href="/">Newsroom</a></li>
                    <li><a href="/blog">Blogs</a></li>
                    <li><a href="/career">Careers</a></li>
                    
  
                  </ul>
                </div>
             

<div className="image-grid">
  <div className="image-item">
  <img src={`${Url.imageUrl}footer/aws_partner_network.png`} height={100} width={100} alt="ai_experts" />
  </div>
  <div className="image-item">
    <img src={`${Url.imageUrl}footer/clutch.png`} height={100} width={100} alt="ai_experts" />
  </div>
  <div className="image-item">
    <img src={`${Url.imageUrl}footer/goodfirms.png`} height={200} width={100} alt="ai_experts" style={{marginTop:"-20px"}} />
  </div>
  <div className="image-item">
    <img src={`${Url.imageUrl}footer/google.png`} height={100} width={100} alt="ai_experts" />
  </div>
  <div className="image-item">
    <img src={Image3} height={200} width={200} alt="bombay_chembers"  loading="lazy"></img>
  </div>
</div>


                
              </div>
            </div>
          </div>
        );

 

     
    default:
      return null;
  }
};
